import { useTranslation } from 'react-i18next';
import { Unlock as UnlockIcon } from '@vgno/icons';

import { Button } from '../../../Button/Button';
import { ParentalControlsHeader } from '../../shared/ParentalControlHeader/ParentalControlsHeader';

import type { FC } from 'react';

import * as styles from './DisabledParentalControls.module.scss';

interface DisabledParentalControlProps {
  handleClose: () => void;
}

const DisabledParentalControls: FC<DisabledParentalControlProps> = ({
  handleClose,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ParentalControlsHeader
        titleText={t('Parental controls deactivated')}
        subtitleText={t('Activate parental controls at any time')}
      />
      <div className={styles.iconContainer}>
        <UnlockIcon className={styles.icon}></UnlockIcon>
      </div>
      <Button
        variant="contained"
        size="medium"
        className={styles.button}
        onClick={handleClose}
      >
        {t('Close')}
      </Button>
    </>
  );
};

export { DisabledParentalControls };
